import React, {useEffect, useState} from "react";
import { Modal } from 'react-bootstrap';
import {Link} from 'react-router-dom';
import { images } from '../../assets/image'
import {userProfileService} from "../../services/profile.service";
import {ASSET_ENDPOINT} from "../../environment";


export const FindMemberModal = (props:any) => {

    const [show, setShow] = useState(props.show);
    const [nextPage, setNextPage] = useState(1);
    const [members, setMembers] = useState([]);
    const [searchVal, setSearch] = useState('');
    const handleClose = () => setShow(false);

    useEffect(() => {
        userProfileService.findMembers(nextPage).then(({data} : any) => {
            if (data.status_code == 200){
                setMembers(data.user.data)
                setNextPage(parseInt(data.user.current_page) + 1 )
            }
        })
    }, []);


    let handleScroll = (e : any) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom) {
            userProfileService.findMembers(nextPage,searchVal).then(({data} : any) => {
                if (data.status_code == 200){
                    if (data.user.data.length  > 0) {
                        data.user.data.map((val: any) => {
                            // @ts-ignore
                            members.push(val);
                        })
                        setMembers(members)
                        setNextPage(parseInt(data.user.current_page) + 1)
                    }
                }
            })
        }
    }

    let search = (e : any) => {
        setSearch(e.target.value)
        userProfileService.findMembers(1,e.target.value).then(({data} : any) => {
            if (data.status_code == 200){
                if (data.user.data.length  > 0) {
                    setMembers(data.user.data)
                    setNextPage(parseInt(data.user.current_page) + 1)
                }
            }
        })

    }

    let unfollowUser = (id : number) => {
        userProfileService.unfollow(id).then(({data}:any) => {
            if (data.status_code == 200){
                let newMembers : any= [];
                members.map((member:any) => {
                    if (member.id == id){
                        member.is_followed_count = 0
                        props.setFollowingCount(parseInt(props.followingCount)-1)
                    }
                    newMembers.push(member)
                })
                setMembers(newMembers);
            }
        })
    }

    let followUser = (id:number) => {
        userProfileService.follow(id).then(({data}:any) => {
            if (data.status_code == 200){
                let newMembers :any = [];
                members.map((member:any) => {
                    if (member.id == id){
                        member.is_followed_count = 1
                        props.setFollowingCount(parseInt(props.followingCount)+1)
                    }
                    newMembers.push(member)
                })
                setMembers(newMembers);
            }
        })
    }

    return(
        <Modal show={show} className="rt-thememodal rt-findmembermodal" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body>
                <div className="rt-thememodalbox rt-findmembermodalbox">
                    <button className="rt-close" onClick={props.onHide}><i className="icon-cross"></i></button>
                    <div className="rt-findmembercontent">
                        <div className="rt-modaltitle">
                            <h3>FIND MEMBERS</h3>
                        </div>
                        <form className="rt-formtheme">
                            <fieldset>
                                <div className="rt-searchbox">
                                    <div className="rt-fieldholder">
                                        <input type="search" className="form-control" name="search" id="search-field" placeholder="" onChange={e => search(e)}/>
                                        <label htmlFor="search-fieldfield">SEARCH</label>
                                    </div>
                                </div>
                                <ul className="rt-memberlist"  onScroll={e => handleScroll(e)}>
                                    {members.map((member:any) => {
                                        return (<li>
                                            <div className="rt-themecardbox">
                                                <figure className="rt-roundimage">
                                                    <img src={ASSET_ENDPOINT+'images/'+member.avatar} alt="" />
                                                </figure>
                                                <div className="rt-themecontent">
                                                    <h4>{member.full_name}</h4>
                                                    <span>{member.position}</span>
                                                </div>
                                            </div>
                                            {member.is_followed_count > 0 ?
                                                <button type="button" className="rt-btn rt-black-btn" onClick={() => unfollowUser(member.id)}>UNFOLLOW</button> :
                                                <button type="button" className="rt-btn rt-black-btn" onClick={() => followUser(member.id)}>FOLLOW</button>
                                            }
                                        </li>)
                                    })}
                                </ul>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}
